import { CoverCodeListList, LiabilityCodeListList, PremiumCodeListList, StatusList, } from '@zurich/api/claim';
import { createArrayUtils, UnknownType } from '@zurich/common/utils';
export const claimLiability = createArrayUtils(LiabilityCodeListList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'claim:liabilityStatus',
});
export const claimCover = createArrayUtils(CoverCodeListList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'claim:coverageState',
});
export const claimStatus = createArrayUtils(StatusList, {
    unknownType: UnknownType.STRING,
    // Note !!!TRANSLATION!!!: because it is used in the search where claim.json is not loaded, we use the app.json
    translationPrefix: 'claim.claimState',
});
export const claimPremium = createArrayUtils(PremiumCodeListList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'claim:premiumCover',
});
// NOTE: Ask Dorna Nasseri how to refactor this.
export const claimPremiumGetCode = (t, value) => {
    if (!value) {
        return `O - ${claimPremium.getTranslatedValue(t, 'O')}`;
    }
    const splitValue = value.split('/', 2);
    if (splitValue &&
        splitValue.length > 1 &&
        claimPremium.valueIsPartOfArray(splitValue[1])) {
        return splitValue[1];
    }
    if (splitValue?.length && claimPremium.valueIsPartOfArray(splitValue[0])) {
        return splitValue[0];
    }
    return '-';
};
